import React from 'react';
import ReactDOM from 'react-dom/client';

import './i18n';
import App from './App';
import {
  applyFieldContrast,
  applyTheme,
  getStoredFieldContrast,
  resolveInitialTheme,
} from '@/lib/theme';
import './styles/globals.css';

// Resolve theme before first paint to avoid flash of incorrect theme.
applyTheme(resolveInitialTheme());
applyFieldContrast(getStoredFieldContrast());

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('EFS frontend: #root element missing in index.html');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
